/* ============================================================
   RIPT Skin Systems — theme.js
   All interactive behaviour. No framework dependencies.
   ============================================================ */

(function () {
  'use strict';

  /* ── ANNOUNCEMENT BAR ────────────────────────────────── */
  var annClose = document.getElementById('annClose');
  var annBar   = document.getElementById('annBar');
  if (annClose && annBar) {
    if (sessionStorage.getItem('ript_ann_closed')) {
      annBar.style.display = 'none';
    }
    annClose.addEventListener('click', function () {
      annBar.style.height = '0';
      annBar.style.overflow = 'hidden';
      annBar.style.transition = 'height 0.3s';
      sessionStorage.setItem('ript_ann_closed', '1');
    });
  }

  /* ── MOBILE NAV ──────────────────────────────────────── */
  var hamburger  = document.getElementById('navHamburger');
  var drawer     = document.getElementById('mobileNavDrawer');
  var overlay    = document.getElementById('mobileNavOverlay');
  var closeBtn   = document.getElementById('mobileNavClose');

  function openMobileNav() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay && overlay.classList.add('open');
    hamburger && hamburger.classList.add('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawer.focus();
  }
  function closeMobileNav() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay && overlay.classList.remove('open');
    hamburger && hamburger.classList.remove('open');
    hamburger && hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger && hamburger.addEventListener('click', openMobileNav);
  closeBtn  && closeBtn.addEventListener('click', closeMobileNav);
  overlay   && overlay.addEventListener('click', closeMobileNav);

  /* Mobile sub-menus */
  window.toggleMobileSub = function (id, btn) {
    var sub = document.getElementById(id);
    if (!sub) return;
    var isOpen = sub.classList.contains('open');
    document.querySelectorAll('.mobile-nav-sub').forEach(function (s) { s.classList.remove('open'); });
    document.querySelectorAll('.mobile-nav-link').forEach(function (b) { b.classList.remove('open'); });
    if (!isOpen) { sub.classList.add('open'); btn.classList.add('open'); }
  };

  /* ── CART DRAWER ─────────────────────────────────────── */
  var cartOverlay = document.getElementById('cartOverlay');
  var cartDrawer  = document.getElementById('cartDrawer');
  var drawerClose = document.getElementById('drawerClose');
  var drawerCont  = document.getElementById('drawerContinue');
  var cartBtn     = document.getElementById('cartBtn');

  window.openCartDrawer = function () {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay && cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  };
  window.closeCartDrawer = function () {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay && cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  };

  cartBtn      && cartBtn.addEventListener('click', window.openCartDrawer);
  drawerClose  && drawerClose.addEventListener('click', window.closeCartDrawer);
  drawerCont   && drawerCont.addEventListener('click', window.closeCartDrawer);
  cartOverlay  && cartOverlay.addEventListener('click', window.closeCartDrawer);

  /* Cart badge sync */
  function updateBadge(count) {
    var badge = document.getElementById('cartBadge');
    if (!badge) return;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'flex' : 'none';
    badge.classList.remove('bump');
    void badge.offsetWidth;
    badge.classList.add('bump');
    /* Update drawer item count */
    var drawerCount = document.getElementById('drawerItemCount');
    if (drawerCount) drawerCount.textContent = count + ' item' + (count !== 1 ? 's' : '');
  }
  if (window.RIPT) updateBadge(window.RIPT.cartCount || 0);

  /* Refresh cart drawer HTML — re-fetch the page and extract the drawer */
  function refreshCartDrawer() {
    fetch(window.location.pathname, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        if (!html) return;
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newDrawer = temp.querySelector('#cartDrawer');
        if (!newDrawer) return;
        var oldDrawer = document.getElementById('cartDrawer');
        if (!oldDrawer) return;
        /* Preserve open state */
        var wasOpen = oldDrawer.classList.contains('open');
        /* Replace inner content (keep the drawer shell) */
        oldDrawer.innerHTML = newDrawer.innerHTML;
        if (wasOpen) oldDrawer.classList.add('open');
        /* Re-cache and re-bind */
        drawerClose = document.getElementById('drawerClose');
        drawerCont  = document.getElementById('drawerContinue');
        drawerClose && drawerClose.addEventListener('click', window.closeCartDrawer);
        drawerCont  && drawerCont.addEventListener('click', window.closeCartDrawer);
        bindDrawerControls();
      })
      .catch(function () {});
  }

  /* Drawer controls — wrapped in function for re-binding after AJAX refresh */
  function bindDrawerControls() {
    /* Qty buttons */
    document.querySelectorAll('.qty-btn').forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function () {
        var key   = btn.dataset.key;
        var row   = btn.closest('.cart-item');
        var numEl = row && row.querySelector('.qty-num');
        var current = numEl ? parseInt(numEl.textContent) : 1;
        var newQty  = btn.classList.contains('qty-minus') ? Math.max(0, current - 1) : current + 1;
        var updates = {}; updates[key] = newQty;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateBadge(cart.item_count);
          window.RIPT && (window.RIPT.cartCount = cart.item_count);
          refreshCartDrawer();
        });
      });
    });

    /* Remove buttons */
    document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function () {
        var key     = btn.dataset.key;
        var row     = btn.closest('.cart-item');
        var updates = {}; updates[key] = 0;
        if (row) {
          row.style.opacity = '0';
          row.style.transform = 'translateX(20px)';
          row.style.transition = 'all 0.2s';
        }
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateBadge(cart.item_count);
          window.RIPT && (window.RIPT.cartCount = cart.item_count);
          refreshCartDrawer();
        });
      });
    });

    /* Upsell add buttons */
    document.querySelectorAll('.upsell-add').forEach(function (btn) {
      if (btn._bound) return;
      btn._bound = true;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var variantId = btn.dataset.variantId;
        btn.textContent = 'ADDING...';
        btn.disabled = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = '✓ ADDED';
          btn.classList.add('added');
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            updateBadge(c.item_count);
            window.RIPT && (window.RIPT.cartCount = c.item_count);
            refreshCartDrawer();
          });
        });
      });
    });
  }
  bindDrawerControls();

  /* ── KIT CTA BUTTONS (hero + cta-section) ───────────── */
  document.querySelectorAll('.js-atc-kit').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      var variantId = parseInt(btn.dataset.variantId);
      if (!variantId) return; /* no variant linked — follow href */
      e.preventDefault();
      var originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateBadge(cart.item_count);
            window.RIPT && (window.RIPT.cartCount = cart.item_count);
            refreshCartDrawer();
            window.openCartDrawer && window.openCartDrawer();
            btn.textContent = originalText;
          });
      })
      .catch(function () { btn.textContent = originalText; });
    });
  });

  /* ── PRODUCT CARD ADD TO CART ────────────────────────── */
  document.querySelectorAll('.product-card-atc').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = parseInt(btn.dataset.variantId);
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.textContent = 'ADDING...';
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        btn.textContent = '✓ ADDED';
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateBadge(cart.item_count);
            window.RIPT && (window.RIPT.cartCount = cart.item_count);
            refreshCartDrawer();
            window.openCartDrawer && window.openCartDrawer();
          });
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 2000);
      })
      .catch(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      });
    });
  });

  /* ── EMAIL POPUP ─────────────────────────────────────── */
  var popupOverlay = document.getElementById('popupOverlay');
  var popupClose   = document.getElementById('popupClose');
  var popupDecline = document.getElementById('popupDecline');
  var popupSubmit  = document.getElementById('popupSubmit');
  var popupEmail   = document.getElementById('popupEmail');
  var popupForm    = document.getElementById('popupForm');
  var popupSuccess = document.getElementById('popupSuccess');
  var popupFired   = false;

  /* 7-day dismiss via localStorage */
  function isPopupDismissed() {
    try {
      var ts = localStorage.getItem('ript_popup_dismissed');
      if (!ts) return false;
      return (Date.now() - parseInt(ts, 10)) < 7 * 24 * 60 * 60 * 1000;
    } catch (e) { return false; }
  }

  /* Popup countdown timer — 10 minutes from open */
  var popupClockEl = document.getElementById('popupClock');
  var popupTimerEl = document.getElementById('popupTimer');
  var popupCountdown = null;
  var popupSecsLeft = 600; /* 10 minutes */

  function pad2(n) { return n < 10 ? '0' + n : String(n); }

  function tickPopupTimer() {
    if (popupSecsLeft <= 0) {
      clearInterval(popupCountdown);
      if (popupClockEl) popupClockEl.textContent = '0:00';
      if (popupTimerEl) popupTimerEl.classList.add('expired');
      return;
    }
    popupSecsLeft--;
    var m = Math.floor(popupSecsLeft / 60);
    var s = popupSecsLeft % 60;
    if (popupClockEl) popupClockEl.textContent = m + ':' + pad2(s);
    /* Pulse when under 2 minutes */
    if (popupSecsLeft <= 120 && popupTimerEl) popupTimerEl.classList.add('urgent');
  }

  function openPopup() {
    if (!popupOverlay || popupFired) return;
    if (isPopupDismissed()) return;
    if (document.cookie.indexOf('klaviyoSubscribed') > -1) return;
    popupFired = true;
    popupOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    /* Start countdown */
    if (popupClockEl && !popupCountdown) {
      popupCountdown = setInterval(tickPopupTimer, 1000);
    }
  }
  function closePopup() {
    if (!popupOverlay) return;
    popupOverlay.classList.remove('open');
    document.body.style.overflow = '';
    if (popupCountdown) { clearInterval(popupCountdown); popupCountdown = null; }
    try { localStorage.setItem('ript_popup_dismissed', String(Date.now())); } catch (e) {}
  }

  popupClose   && popupClose.addEventListener('click', closePopup);
  popupDecline && popupDecline.addEventListener('click', closePopup);
  popupOverlay && popupOverlay.addEventListener('click', function (e) {
    if (e.target === popupOverlay) closePopup();
  });

  if (popupOverlay && !isPopupDismissed()) {
    /* Trigger 1 — 30-second idle timer */
    var popupTimer = setTimeout(openPopup, 45000);

    /* Trigger 2 — Scroll depth 40% */
    window.addEventListener('scroll', function onScroll() {
      var depth = window.scrollY / (document.body.scrollHeight - window.innerHeight);
      if (depth >= 0.50) {
        window.removeEventListener('scroll', onScroll);
        clearTimeout(popupTimer);
        setTimeout(openPopup, 400);
      }
    }, { passive: true });

    /* Trigger 3 — Exit intent (desktop only) */
    if (window.innerWidth > 768) {
      document.addEventListener('mouseleave', function onLeave(e) {
        if (e.clientY <= 5) {
          document.removeEventListener('mouseleave', onLeave);
          clearTimeout(popupTimer);
          openPopup();
        }
      });
    }
  }

  /* Popup form submit */
  if (popupSubmit) {
    popupSubmit.addEventListener('click', function () {
      var email = popupEmail && popupEmail.value;
      if (!email || !email.includes('@')) {
        popupEmail && popupEmail.focus();
        if (popupEmail) {
          popupEmail.style.borderColor = 'var(--red-accent)';
          popupEmail.classList.add('shake');
          setTimeout(function () { popupEmail.classList.remove('shake'); }, 500);
        }
        return;
      }
      popupSubmit.textContent = 'SENDING...';
      popupSubmit.disabled = true;
      /* TODO: POST to Klaviyo list endpoint with fetch() */
      if (popupForm)    popupForm.style.display    = 'none';
      if (popupSuccess) popupSuccess.style.display = 'flex';
      try { localStorage.setItem('ript_popup_dismissed', String(Date.now())); } catch (e) {}
    });
  }

  /* ── FAQ ACCORDION ──────────────────────────────────── */
  window.toggleFAQ = function (questionEl) {
    var item   = questionEl.parentElement;
    var toggle = questionEl.querySelector('.faq-toggle');
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function (openItem) {
      openItem.classList.remove('open');
      var openToggle = openItem.querySelector('.faq-toggle');
      if (openToggle) openToggle.textContent = '+';
    });
    if (!isOpen) {
      item.classList.add('open');
      if (toggle) toggle.textContent = '×';
    }
  };

  /* ── GLOBAL ESC KEY ──────────────────────────────────── */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeMobileNav();
    window.closeCartDrawer && window.closeCartDrawer();
    closePopup();
  });

  /* ── STICKY BAR ──────────────────────────────────────── */
  var stickyBar = document.getElementById('stickyBar');
  var heroSection = document.getElementById('hero');
  if (stickyBar && heroSection) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }, { threshold: 0.1 });
    stickyObserver.observe(heroSection);
  }

  /* ── SCROLL REVEAL ───────────────────────────────────── */
  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    if ('IntersectionObserver' in window && !prefersReducedMotion) {
      var revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
      revealEls.forEach(function (el) { revealObserver.observe(el); });
    } else {
      /* Fallback for old browsers or reduced motion — just show everything */
      revealEls.forEach(function (el) { el.classList.add('visible'); });
    }
  }

  /* ── ANIMATED STAT COUNTERS ────────────────────────── */
  function animateStatNumbers() {
    var stats = document.querySelectorAll('.stat-number[data-count]');
    if (!stats.length || prefersReducedMotion) return;
    var statsObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.dataset.count);
        var suffix = el.dataset.suffix || '';
        var duration = 1200;
        var start = 0;
        var startTime = null;
        var isFloat = target % 1 !== 0;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3); /* easeOutCubic */
          var current = start + (target - start) * eased;
          el.textContent = (isFloat ? current.toFixed(1) : Math.round(current)) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        statsObserver.unobserve(el);
      });
    }, { threshold: 0.5 });
    stats.forEach(function (el) { statsObserver.observe(el); });
  }
  animateStatNumbers();

  /* ── SMOOTH SCROLL for anchor links ─────────────────── */
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(a.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

})();
